import * as React from 'react';

import { MilleFeuille, MilleFeuilleMain } from '@/layouts/MilleFeuille';
import type { WebflowHybridPageProps } from '@/lib/webflow-poc';
import { usesWebflowNavChrome } from '@/lib/webflow-poc/navigation-chrome';
import { WebflowBodyContent } from '@/lib/webflow-poc/WebflowBodyContent';
import { FooterRender } from '@/modules/website-builder';

type WebflowPageShellProps = {
  webflow: WebflowHybridPageProps['webflow'];
  navigationChrome: WebflowHybridPageProps['navigationChrome'];
  tenant: WebflowHybridPageProps['tenant'];
};

/**
 * Renders a static Webflow page with either:
 * - WEBFLOW / WEBFLOW_NATIVE: full page, no Tradewing header/footer
 * - TRADEWING chrome: content island inside Tradewing nav + footer
 */
export const WebflowPageShell: React.FC<WebflowPageShellProps> = ({
  webflow,
  navigationChrome,
  tenant,
}) => {
  const content = (
    <WebflowBodyContent page={webflow} navigationChrome={navigationChrome} />
  );

  if (usesWebflowNavChrome(navigationChrome)) {
    return content;
  }

  return (
    <MilleFeuille>
      <MilleFeuilleMain>{content}</MilleFeuilleMain>
      {tenant ? <FooterRender tenant={tenant as any} /> : null}
    </MilleFeuille>
  );
};
